import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CultivosAforosViewModel, TwUnidadInspeccionViewModel, TwUnidadInspeccionViewModelExtended } from './unidad-inspeccion-datosbasicos.types';
import { RecintoUnidadInspeccionItemViewModel } from '../buscadores/unidades-inspeccion/buscador-unidad-inspeccion.types';

@Injectable()
export class UnidadInspeccionService {
    private unidadInspeccionEndpoint = this.baseUrl + 'api/campanias/unidadinspeccion/';
    private recintoUnidadInspeccionEndpoint = this.baseUrl + 'api/campanias/recintounidadinspeccion/';

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    getUI(id: number): Observable<TwUnidadInspeccionViewModelExtended> {
        return this.http.get<TwUnidadInspeccionViewModelExtended>(this.unidadInspeccionEndpoint + id);
    }

    insertOrUpdateUI(unidadInspeccion: TwUnidadInspeccionViewModel): Observable<any> {
        delete unidadInspeccion.IdTipoSolicitudCam; // No se necesita éste campo
        return this.http.post<TwUnidadInspeccionViewModel>(this.unidadInspeccionEndpoint, unidadInspeccion);
    }

    desvinculaUI(idUnidadInspeccion: number): Observable<any> {
        return this.http.delete<any>(this.unidadInspeccionEndpoint + idUnidadInspeccion);
    }

    darDeBajaUI(idRecintoUnidadInspeccion: number): Observable<any> {
        return this.http.delete<any>(this.unidadInspeccionEndpoint + 'Baja/' + idRecintoUnidadInspeccion);
    }

    suspenderUI(idRecintoUnidadInspeccion: number): Observable<any> {
        return this.http.delete<any>(this.unidadInspeccionEndpoint + 'Suspender/' + idRecintoUnidadInspeccion);
    }

    // Operación a nivel de recinto-UI
    desvincularRecintoUI(idRecintoUnidadInspeccion: number): Observable<any> {
        return this.http.delete<any>(this.recintoUnidadInspeccionEndpoint + idRecintoUnidadInspeccion);
    }

    checkHabilitadaParaCortes(idUi: number): Observable<boolean> {
        return this.http.get<boolean>(this.unidadInspeccionEndpoint + 'CortesHabilitados/' + idUi);
    }

    getCultivosAforosCortesByIdUi(idUi: number): Observable<CultivosAforosViewModel[]> {
        return this.http.get<CultivosAforosViewModel[]>(this.recintoUnidadInspeccionEndpoint + 'CultivosAforosCortes/' + idUi);
    }

    getRecintosUiByIdUi(idUi: number): Observable<RecintoUnidadInspeccionItemViewModel[]> {
        return this.http.get<RecintoUnidadInspeccionItemViewModel[]>(this.recintoUnidadInspeccionEndpoint + idUi);
    }
}
